import { Injectable, inject } from '@angular/core';
import { ApiService } from 'capiche-api';
import { UserService } from 'capiche-auth';
import { CapicheLoggerService } from 'capiche-logger';
import { CAPICHE_TEXT_PROCESSOR_CONFIG } from '../capiche-text-processor.config';

/**
 * Flushes a client-side-batched getSuggestions call count to
 * `POST /v1/usageCounters/getSuggestions` (CSW-1643). See UsageCounterService
 * for the batching itself — this repository is just the transport.
 */
@Injectable({
  providedIn: 'root',
})
export class UsageCounterRepository extends ApiService {
  private readonly config = inject(CAPICHE_TEXT_PROCESSOR_CONFIG);
  private capicheApiBaseUrl = this.config.baseApiUrl;
  private usageCountersEndpoint = `${this.capicheApiBaseUrl}/v1/usageCounters`;

  override logger: CapicheLoggerService = new CapicheLoggerService('usageCounterRepository:', false);

  constructor(userService: UserService) {
    super(userService);
  }

  public async recordGetSuggestions(count: number) {
    return await this.post(`${this.usageCountersEndpoint}/getSuggestions`, { count });
  }
}
